import {  createSlice } from '@reduxjs/toolkit';

const initialState = {
    loginData: [],
    isLoggedIn: false
}
const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
      clearLoginData : (state) => {
        state.loginData = [];
        state.isLoggedIn = false;
      },
      addLoginResponse: (state, action) => {
         state.loginData = action.payload;
         state.isLoggedIn = true;
      }
    }
});

export const { clearLoginData, addLoginResponse } =  loginSlice.actions;
export default loginSlice.reducer;